<template>
    <div class="fluid fill-height fill-width" style="width: 100%;flex: 1 1 auto;position: relative;">

        <div class="fill-height main-pdf-viewer" style="right: 0px;height: 100%;" v-bind:style="{right: (fullWidth) ? '0' : '500px'}">
            <div class="m-portlet__body" style="height: 100%;padding: 0;">

                <div id="outerContainer" >

                    <div id="mainContainer">

                        <div class="toolbar">
                            <div id="toolbarContainer">
                                <div id="toolbarViewer">
                                    <div id="toolbarViewerLeft">
                                        <div class="toolbarButtonSpacer"></div>
                                        <div class="splitToolbarButton">
                                            <button class="toolbarButton pageUp" title="Previous Page" @click="previousPage" tabindex="13" data-l10n-id="previous">
                                                <span data-l10n-id="previous_label">Previous</span>
                                            </button>
                                            <div class="splitToolbarButtonSeparator"></div>
                                            <button class="toolbarButton pageDown" title="Next Page" @click="nextPage" tabindex="14" data-l10n-id="next">
                                                <span data-l10n-id="next_label">Next</span>
                                            </button>
                                        </div>
                                        <input type="number" v-model="selectedPage" @blur="exactPage" v-on:keyup.13="exactPage" class="toolbarField pageNumber" title="Page" value="1" size="4" min="1" tabindex="15" data-l10n-id="page">
                                        <span class="toolbarLabel"> {{file_pages}}</span>
                                    </div>
                                    <!--<div id="toolbarViewerMiddle">
                                        <div class="splitToolbarButton">
                                            <button id="zoomOut" class="toolbarButton zoomOut" title="Zoom Out" @click="zoomOut" tabindex="21" data-l10n-id="zoom_out">
                                                <span data-l10n-id="zoom_out_label">Zoom Out</span>
                                            </button>
                                            <div class="splitToolbarButtonSeparator"></div>
                                            <button id="zoomIn" class="toolbarButton zoomIn" title="Zoom In" @click="zoomIn" tabindex="22" data-l10n-id="zoom_in">
                                                <span data-l10n-id="zoom_in_label">Zoom In</span>
                                            </button>
                                        </div>
                                    </div>-->
                                </div>
                            </div>
                        </div>

                        <div id="viewerContainer" tabindex="0">
                            <div id="pdf-viewer" @contextmenu="disableContextMenu($event)">
                                <v-progress-circular v-if="pageLoading" style="margin: 50px auto auto;"
                                                     :size="200"
                                                     :width="7"
                                                     color="primary"
                                                     indeterminate
                                >
                                    {{ $t("Loading page...") }}
                                </v-progress-circular>

                                <v-card v-if="pageError" plain class="card-error">
                                    <v-card-title primary-title class="card-error-title">
                                        {{$t("Error rendering this page")}}
                                    </v-card-title>
                                </v-card>
                            </div>
                        </div>

                    </div> <!-- mainContainer -->

                </div> <!-- outerContainer -->

            </div>
        </div>


    </div>
</template>

<script>

    import ExternalLoader from '@/lib/external-loader'
    import FilesRepository from '@/repositories/FilesRepository';

    import { VProgressCircular, VCard, VCardTitle } from 'vuetify/lib'

    export default {
        name: 'PdfViewer',
        components: {
            VProgressCircular, VCard, VCardTitle
        },
        mounted() {
            // Allow to load pages
            this.loadPages = true;
            // load Resources
            let loader = new ExternalLoader(document);
            let resources = ["/vendor/image/tiff.min.js", "/vendor/jquery-2.2.3.min.js", "/vendor/pdf/viewer.css"];
            loader.loadResource("/vendor/pdf/locale/locale.properties");
            loader.load(resources).then(() => { this.loaded = true });
            this.$root.$emit('show-register-ad');
        },
        beforeDestroy () {
            // Stop loading pages
            this.loadPages = false;
        },
        props: {
            fullWidth: Boolean,
            hash: String,
            token: String,
            file: Object
        },
        data () {
            return {
                loaded: false,

                access_token: "",
                currentPage: 0,
                selectedPage: 0,
                nextPageToLoad: null,
                file_pages: 0,

                firstTime: true,
                loadPages: true,
                pagesLoaded: [],
                pagesError: [],
                pagesLoading: [],

                pageLoading: false,
                pageError: false,

                zoom: 1,
            }
        },
        watch: {
            loaded: function () {
                this.load();
            },
            hash: function () {
                this.load();
            },
            currentPage: function (newValue, oldValue) {
                newValue = Number(newValue);
                oldValue = Number(oldValue);
                this.changePage(newValue, oldValue);
            }
        },
        methods: {
            disableContextMenu: function(e) {
                e.preventDefault();
            },
            /**
             * Load functions
             */
            load() {
                if (this.hash && this.loaded) {
                    this.getPdfAccessToken();
                }
            },
            getPdfAccessToken() {
                FilesRepository.getFileJson(this.hash, this.token)
                    .then((response) => {
                        if (response && response.data && response.data.access_token) {
                            this.access_token = response.data.access_token;
                            this.file_pages = response.data.file_pages;
                            this.initPagesLoading();
                        }
                    })
                    .catch((error) => {
                        this.error(error);
                    });
            },

            initPagesLoading() {
                this.currentPage = 1;
                this.selectedPage = this.currentPage;
                this.pagesLoaded = [];
                this.pageLoading = false;
                this.pageError = false;
                this.loadPage();
                // this.loadPage();
            },

            getFirstUnloadedPage() {
                for (let i=1 ; i<=this.file_pages ; i++) {
                    // No loaded and no loading
                    if (this.pagesLoaded.indexOf(i) === -1 && this.pagesLoading.indexOf(i) === -1) {
                        this.pagesLoading.push(i);
                        return i;
                    }
                }
                return -1;
            },

            loadPage() {
                if (!this.loadPages) return;
                let t1 = Date.now();

                // Decide which page to load
                let page = 0;
                if (this.nextPageToLoad && this.pagesLoaded.indexOf(this.nextPageToLoad) === -1) {
                    page = this.nextPageToLoad;
                    this.nextPageToLoad = null;
                } else {
                    page = this.getFirstUnloadedPage();
                }

                // Check finish
                if (page < 0 || page > this.file_pages) {
                    return;
                }

                // Load the page
                FilesRepository.getFilePage(this.access_token, this.token, page)
                    .then((response) => {
                        if (!this.loadPages) return;

                        // Put page to viewer
                        try {
                            this.loadTiff(response.data, page);
                        } catch (err) {
                            console.error(err);
                            this.pagesLoaded.push(page);
                            if (this.pagesLoaded.length < this.file_pages) {
                                this.loadPage()
                            }
                            return;
                        }

                        // Mark the page as loaded
                        this.pagesLoaded.push(page);
                        this.pagesLoading.splice(this.pagesLoading.indexOf(page), 1);

                        // If we are on this page, show it
                        if (this.currentPage === page) {
                            this.showPage(page);
                        }

                        // Finish loading on first page
                        if (page === 1) {
                            this.finished();
                        }

                        let t2 = Date.now();
                        console.log("LOADED " + page + " " + (t2-t1))

                        // Load next page
                        this.loadPage();

                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 403) {
                            this.pagesError.push(page);
                        } else {
                            this.error(error);
                        }
                    });
            },

            loadTiff(data, page) {
                if (!this.loadPages) return;
                let tiff = new Tiff({buffer: data});
                let tiffCanvas = tiff.toCanvas();
                tiffCanvas.id = "page-" + page;
                tiffCanvas.style.display = "none";
                tiffCanvas.className = "pdf-page-canvas";
                document.getElementById("pdf-viewer").append(tiffCanvas);
            },

            /**
             * Page buttons
             */
            exactPage() {
                if (this.selectedPage < 1 || this.selectedPage > this.file_pages) {
                    this.selectedPage = this.currentPage;
                } else {
                    this.currentPage = Number(this.selectedPage);
                }
            },

            nextPage() {
                if (this.currentPage < this.file_pages) {
                    this.currentPage = this.currentPage + 1;
                    this.selectedPage = this.currentPage;
                }
            },

            previousPage() {
                if (this.currentPage > 1) {
                    this.currentPage = this.currentPage - 1;
                    this.selectedPage = this.currentPage;
                }
            },

            /**
             * Zoom buttons
             */
            zoomIn() {
                // // Load canvas
                // let canvas = document.getElementById("page-1");
                // let context = canvas.getContext('2d');
                //
                // // Get values
                // let width = context.canvas.width;
                // let height = context.canvas.height;
                // let newWidth = width * 1.25;
                // let newHeight = width * 1.25;
                //
                // // Create an image from the canvas
                // var imageObject=new Image();
                // imageObject.onload = function(){
                //     // Resize canvas
                //     context.canvas.width = newWidth;
                //     context.canvas.height = newHeight;
                //     // Scale
                //     context.scale(1.25, 1.25);
                //     // Redraw image
                //     context.drawImage(imageObject,0,0);
                // };
                // imageObject.src=canvas.toDataURL();
            },

            zoomOut() {
                // // Load canvas
                // let canvas = document.getElementById("page-1");
                // let context = canvas.getContext('2d');
                //
                // // Get values
                // let width = context.canvas.width;
                // let height = context.canvas.height;
                // let newWidth = width * 0.8;
                // let newHeight = width * 0.8;
                //
                // // Create an image from the canvas
                // var imageObject=new Image();
                // imageObject.onload = function(){
                //     // Resize canvas
                //     context.canvas.width = newWidth;
                //     context.canvas.height = newHeight;
                //     // Scale
                //     context.scale(0.8, 0.8);
                //     // Redraw image
                //     context.drawImage(imageObject,0,0);
                // };
                // imageObject.src=canvas.toDataURL();
            },

            /**
             * Utility Functions
             */
            changePage(newValue, oldValue) {
                if (newValue < 1 || newValue > this.file_pages) {
                    this.currentPage = oldValue;
                } else {
                    this.hidePage(oldValue);
                    this.showPage(newValue);
                }
            },

            showPage(page) {
                if (!this.loadPages) return;
                if (this.pagesLoaded.indexOf(page) !== -1) {
                    this.pageLoading = false;
                    this.pageError = false;
                    document.getElementById("page-"+page).style.display = "inline-block";
                } else if (this.pagesError.indexOf(page) !== -1) {
                    this.pageLoading = false;
                    this.pageError = true;
                } else {
                    this.nextPageToLoad = page;
                    this.pageError = false;
                    this.pageLoading = true;
                }
            },

            hidePage(page) {
                if (!this.loadPages) return;
                if (this.pagesLoaded.indexOf(page) !== -1) {
                    document.getElementById("page-"+page).style.display = "none";
                } else {
                    this.pageLoading = false;
                    this.pageError = false;
                }
            },

            finished() {
                this.$emit('loaded');
            },

            error(error) {
                this.$emit('error', error);
            },
        }
    };
</script>

<style>
    .pdf-page-canvas {
        border: 9px solid transparent;
        background-clip: content-box;
        -o-border-image: url("/vendor/pdf/images/shadow.png") 9 9 repeat;
        border-image: url("/vendor/pdf/images/shadow.png") 9 9 repeat;
    }
</style>
<style scoped>
    .card-error {
        width: 60%;
        margin: auto;
        margin-top: 20px;
    }
    .card-error-title{
        justify-content: center;
    }
    .main-pdf-viewer {
        left: 0;
        top: 0;
        bottom: 0;
        position: absolute;
    }
    #toolbarContainer {
        background-color: #CD5360;
    }
    #pageNumber, #scaleSelectContainer {
        border-color: #CD5360;
    }
    .toolbarButton .zoomIn {
        position: relative;
        margin: 0;
        margin-left: -1px;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
        border-left-color: transparent;
        border-radius: 0;
        float: left;
    }
    .splitToolbarButtonSeparator {
        float: left;
    }
    .toolbarButton .zoomOut {
        position: relative;
        margin: 0;
        margin-right: -1px;
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
        border-right-color: transparent;
        border-radius: 0;
        float: left;
    }

    .splitToolbarButton {
        position: relative;
        float: left;
        margin-right: 4px;
        margin-left: 4px;
        margin: 3px 4px 4px 4px;
        display: inline-block;
    }

    #toolbarViewerLeft {
        float: left;
    }

    .toolbarButtonSpacer {
        position: relative;
        float: left;
    }

    .splitToolbarButton.hiddenSmallView {
        position: relative;
        float: left;
        margin: 3px 2px 4px 0;
        display: inline-block;
    }

    .toolbarButton.pageDown::before {
        content: url("/vendor/pdf/images/toolbarButton-pageDown.png");
    }
    .toolbarButton.pageUp::before {
        content: url("/vendor/pdf/images/toolbarButton-pageUp.png");
    }
    .toolbarButton::before, .secondaryToolbarButton::before {
        position: absolute;
        display: inline-block;
        top: 4px;
        left: 7px;
    }
    .toolbarButton {
        float: left;
    }
</style>
